import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EncryptDecryptService } from 'src/app/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http:HttpClient,private encDecService:EncryptDecryptService) { }

  GetAllAppointmentScheduleSlotLevelDetailsByAppointmentScheduleSlotLevelID(AppointmentScheduleSlotLevelID) {
    return this.http.get<any>(environment.configUrl + 'Appointment/GetAllAppointmentScheduleSlotLevelDetailsByAppointmentScheduleSlotLevelIDPatient?AppointmentScheduleSlotLevelID=' + this.encDecService.enc(AppointmentScheduleSlotLevelID.toString()) + '&CurrentDate=' + new Date())
  }
}
